import { motion } from 'framer-motion';

export default function PartnershipSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-indigo-50 to-white">
      <div className="max-w-6xl mx-auto px-6 text-center">
        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold text-indigo-600 mb-4"
        >
          Our Trusted Partner
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-gray-600 text-lg max-w-2xl mx-auto mb-12"
        >
          At Codexa, we proudly collaborate with Mi-Networks to deliver seamless, scalable, and secure digital solutions.
        </motion.p>

        {/* Partner Info Block */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:flex items-center justify-between gap-10"
        >
          <img
            src="https://pic.surf/rw" // Replace with real logo
            alt="Mi-Networks"
            className="w-40 h-auto mx-auto md:mx-0"
          />
          <div className="text-left mt-6 md:mt-0 flex-1">
            <h3 className="text-2xl font-semibold text-indigo-700 mb-2">Mi-Networks</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Mi-Networks brings cutting-edge infrastructure and cloud expertise to support Codexa’s mission of crafting powerful, reliable, and innovative tech solutions. Together, we're shaping a smarter digital future.
            </p>

            {/* Button */}
            <motion.a
              href="https://mi-networks.web.app/" // Replace with actual link
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-block mt-2 px-6 py-3 bg-indigo-600 text-white rounded-xl font-medium shadow-md hover:bg-indigo-700 transition duration-300"
            >
              Visit Mi-Networks
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
